import { useReduxState } from 'hooks';
import { DisplayFormattedDate } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  analyticsDisabledForAdmin?: boolean;
  lastOpenedDate: string | undefined;
}

const CourseLastOpened = ({
  analyticsDisabledForAdmin,
  lastOpenedDate
}: Props) => {
  const { messages, theme, serverConfig } = useReduxState();

  return (
    <div className="last-opened">
      {lastOpenedDate ? (
        <DisplayFormattedDate
          date={lastOpenedDate}
          withTime={serverConfig.analyticsDatesDisplayTime}
        />
      ) : (
        <span
          style={{
            color: theme.textColorLighter,
            fontWeight: 400
          }}
        >
          {messages.commonNever}
          {analyticsDisabledForAdmin ? (
            <span
              aria-label={messages.tasksIgnoredInfo}
              data-tooltip={messages.tasksIgnoredInfo}
              style={{
                fontSize: '1rem',
                color: theme.textColorLighter,
                marginLeft: 5,
                position: 'relative',
                top: -1
              }}
            >
              <Icon icon="exclamation-triangle" />
            </span>
          ) : null}
        </span>
      )}
    </div>
  );
};

export default CourseLastOpened;
